module.exports = __webpack_public_path__ + "static/infrastructureSelected-ca5d3d9b2b0cf51757aecde5630a229b.svg";